import template from './integrationErrors.template.html';

export default {
  controller: class controller {
    constructor($mdDialog, eventService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.destroyWatch = null;

      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onIntegrationErrors((params) => {
          $mdDialog.show({
            locals: {
              errors: params?.errors || [],
              errorMessage: params?.errorMessage || '',
              integrationName: params?.integrationName || ''
            },
            template,
            clickOutsideToClose: false,
            controllerAs: '$ctrl',
            controller(errors, errorMessage, integrationName) {
              const self = this;
              self.errorMessages = [];
              self.integrationName = integrationName;

              if (errors?.length) {
                const len = errors?.length || 0;
                for (let e = 0; e < len; e += 1) {
                  const error = errors[e];
                  const message = error?.label
                    ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                    : error?.message || error || '';
                  self.errorMessages.push(message);
                }
              } else {
                self.errorMessages.push(errorMessage);
              }

              self.cancel = () => {
                $mdDialog.hide(false);
              };
            }
          });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
